const RADIAN = Math.PI / 180;

const toRadian = function(degree: number): number {
  return RADIAN * degree;
};

export default toRadian;
